module.exports = __webpack_public_path__ + "6fe2e9468077af156cbc641cfda872fb.pdf";